var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBareTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.21474 7.00508C6.58344 4.74711 10.1634 3.25852 11.9547 2.53931C17.069 0.485807 18.1318 0.129092 18.8244 0.117313C18.9768 0.114722 19.3174 0.151169 19.5381 0.324004C19.7244 0.469942 19.7756 0.667083 19.8002 0.805448C19.8247 0.943813 19.8552 1.25901 19.831 1.5053C19.5538 4.31639 18.3546 11.1382 17.7445 14.2866C17.4863 15.6189 16.978 16.0655 16.4859 16.1093C15.4164 16.2043 14.6043 15.427 13.5685 14.7715C11.9476 13.7459 11.032 13.1074 9.45863 12.1065C7.64038 10.9499 8.81907 10.3141 9.85529 9.27518C10.1265 9.00328 14.8386 4.86586 14.9298 4.49053C14.9412 4.44359 14.9518 4.26862 14.8441 4.17622C14.7364 4.08383 14.5775 4.11543 14.4628 4.14055C14.3002 4.17617 11.7108 5.82831 6.69471 9.09696C5.95973 9.58416 5.29401 9.82154 4.69754 9.8091C4.03999 9.79539 2.77512 9.4502 1.83482 9.15514C0.681504 8.79324 -0.235129 8.6019 -0.155311 7.98728C-0.113737 7.66715 0.342947 7.33975 1.21474 7.00508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBareTelegram);
export default __webpack_public_path__ + "static/media/bare-telegram.1799c2364bcaf18dc0fb64b30a0eda05.svg";
export { ForwardRef as ReactComponent };